module.exports = __webpack_public_path__ + "static/media/MEINPV_MENU-normal.d5cc0107.png";